const chartDefaultData = [
    {
      id: "0",
      parent: "",
      name: "KUND",
    },
    {
      id: "1.1",
      parent: "0",
      name: "Januari",
    },
    {
      id: "1.2",
      parent: "0",
      name: "Februari",
    },
    {
        id: "1.3",
        parent: "0",
        name: "Mars",
      },
    {
      id: "1.4",
      parent: "0",
      name: "April",
    },
    {
        id: "1.5",
        parent: "0",
        name: "Maj",
      },
      {
        id: "1.6",
        parent: "0",
        name: "Juni",
      },
      {
        id: "1.7",
        parent: "0",
        name: "Juli",
      },
      {
        id: "1.8",
        parent: "0",
        name: "Augusti",
      },
      {
        id: "1.9",
        parent: "0",
        name: "September",
      },
      {
        id: "1.10",
        parent: "0",
        name: "Oktober",
      },
      {
        id: "1.11",
        parent: "0",
        name: "November",
      },
      {
        id: "1.12",
        parent: "0",
        name: "December",
      },

    /* Bawumia */
    {
      id: "2.1",
      parent: "1.1",
      name: "Jan Child",
      value: 200,
    },

    {
      id: "2.2",
      parent: "1.2",
      name: "Feb Child",
      value: 200,
    },

    {
      id: "2.3",
      parent: "1.3",
      name: "March Child",
      value: 200,
    },

    /* Alan */
    {
      id: "2.4",
      parent: "1.4",
      name: "April Child",
      value: 200,
    },

    {
      id: "2.5",
      parent: "1.5",
      name: "May Child",
      value: 200,
    },

    {
      id: "2.6",
      parent: "1.6",
      name: "June Child",
      value: 200,
    },

    /* Gov */
    {
      id: "2.7",
      parent: "1.7",
      name: "July Child",
      value: 200,
    },

    {
      id: "2.8",
      parent: "1.8",
      name: "Aug Child",
      value: 200,
    },

    {
      id: "2.9",
      parent: "1.9",
      name: "Sep Child",
      value: 200,
    },

    /* Mahama */
    {
      id: "2.10",
      parent: "1.10",
      name: "Oct Child",
      value: 200,
    },

    {
      id: "2.11",
      parent: "1.11",
      name: "Nov CHild",
      value: 200,
    },

    {
      id: "2.12",
      parent: "1.12",
      name: "Dec Child",
      value: 200,
    },

    
];

const defaultLevels = [
    {
        'id': 0,
        'fields': [
            {
                'id': '0',
                'name': 'KUND',
                'parent': ''
            }
        ],
    },
    {
        'id': 1,
        'fields': [
            {
                'id': '1.1',
                'name': 'Januari',
                'parent': '0',
            },
            {
                'id': '1.2',
                'name': 'Februari',
                'parent': '0',
            },
            {
                'id': '1.3',
                'name': 'March',
                'parent': '0',
            },
            {
                'id': '1.4',
                'name': 'April',
            },
            {
                'id': '1.5',
                'name': 'May',
                'parent': '0',
            },
            {
                'id': '1.6',
                'name': 'June',
                'parent': '0',
            },
            {
                'id': '1.7',
                'name': 'July',
                'parent': '0',
            },
            {
                'id': '1.8',
                'name': 'August',
                'parent': '0',
            },
            {
                'id': '1.9',
                'name': 'September',
                'parent': '0',
            },
            {
                'id': '1.10',
                'name': 'October',
                'parent': '0',
            },
            {
                'id': '1.11',
                'name': 'November',
                'parent': '0',
            },
            {
                'id': '1.12',
                'name': 'December',
                'parent': '0',
            }
        ],
    },
    {
        'id': 2,
        'fields': [
            {
                id: "2.01",
                parent: "1.1",
                name: "Jan Child",
                value: 200,
              },
          
              {
                id: "2.02",
                parent: "1.2",
                name: "Feb Child",
                value: 200,
              },
          
              {
                id: "2.03",
                parent: "1.3",
                name: "March Child",
                value: 200,
              },
          
              /* Alan */
              {
                id: "2.04",
                parent: "1.4",
                name: "April Child",
                value: 200,
              },
          
              {
                id: "2.05",
                parent: "1.5",
                name: "May Child",
                value: 200,
              },
          
              {
                id: "2.06",
                parent: "1.6",
                name: "June Child",
                value: 200,
              },
          
              /* Gov */
              {
                id: "2.07",
                parent: "1.7",
                name: "July Child",
                value: 200,
              },
          
              {
                id: "2.08",
                parent: "1.8",
                name: "Aug Child",
                value: 200,
              },
          
              {
                id: "2.09",
                parent: "1.9",
                name: "Sep Child",
                value: 200,
              },
          
              /* Mahama */
              {
                id: "2.1",
                parent: "1.10",
                name: "Oct Child",
                value: 200,
              },
          
              {
                id: "2.11",
                parent: "1.11",
                name: "Nov CHild",
                value: 200,
              },
          
              {
                id: "2.12",
                parent: "1.12",
                name: "Dec Child",
                value: 200,
              },
        ],
    },
];

const graphColors = ['#003847', '#496a76', '#869ba4', '#c3cdd0', '#dcdcd2', '#bab9a5', '#99967a', '#dccc9a', '#e7cf90', '#dab654', '#ddd7be', '#e6e1cf', '#edebde'];
const defaultLevelSettings = [{
    level: 1,
    levelIsConstant: false,
    dataLabels: {
        filter: {
            property: 'outerArcLength',
            operator: '>',
            value: 64
        }
    }
}, {
    level: 2,
    color: undefined,
    colorByPoint: true,
    colorVariation: {
        key: 'brightness',
        to: -0.5
    }
},
{
    level: 3,
    color: undefined,
    colorVariation: {
        key: 'brightness',
        to: -0.5
    }
}];

export { chartDefaultData, defaultLevels, graphColors, defaultLevelSettings}